import { createContext, useContext } from 'react';

/**
 * @typedef StateBookingContext
 * @property {object} detailTherapist
 * @property {boolean} isLoadingDetailTherapist
 * @property {object[]} therapistOptions
 * @property {boolean} isLoadingTherapistOptions
 * @property {object[]} servicesOptions
 * @property {boolean} isLoadingServiceOptions
 * @property {import("react").SetStateAction} setFormat24h
 * @property {boolean} format24h
 * @property {import("antd").FormInstance} formInstance
 */

/** @type {StateBookingContext} */
const initialState = {
    detailTherapist: {},
    isLoadingDetailTherapist: false,
    therapistOptions: [],
    isLoadingTherapistOptions: false,
    servicesOptions: [],
    isLoadingServiceOptions: false,
    setFormat24h: () => {},
    format24h: false,
    formInstance: {},
};

const BookingContext = createContext(initialState);

export const useBookingCtx = () => useContext(BookingContext);

export default BookingContext;
